import React from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';
import Button, { type ButtonProps } from '../../Button';

import styles from '../textField.module.scss';

export function TrailingButton(props: ButtonProps<string | undefined>) {
  const { children, className, ...rest } = props;

  const classNames = cx(styles[toCamelCase('textField', 'trailingButton')], className);
  return (
    <Button
      data-testid="textField-button"
      {...rest}
      variant="ghost"
      size="small"
      className={classNames}
    >
      {children}
    </Button>
  );
}

export default TrailingButton;
